import type { AppDispatch } from '@/app/store/store';
import { userContextRtkApi } from '@/shared/features/user-context/infra/adapters/userContextApiSlice';
import type { WishlistMutationResponseDTO } from '../../infra/dto/wishlist.dto';

export function syncWishlistUserContext(
  dispatch: AppDispatch,
  dto: Pick<WishlistMutationResponseDTO, 'wishListItemDesignIds' | 'wishListItemCount'>
) {
  dispatch(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- userContextRtkApi is typed as any
    (userContextRtkApi as any).util.updateQueryData(
      'getUserContext',
      undefined,
      (draft: Record<string, unknown>) => {
        draft['wishListDesignIds'] = dto.wishListItemDesignIds;
        draft['wishlistCount'] = dto.wishListItemCount;
      }
    )
  );
}
